"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionUploadButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const provider_api_firebase_1 = require("@dzambalaorg/provider-api-firebase");
const styled_1 = require("@framework/styled");
const utils_1 = require("../../../../utils");
const dialogs_1 = require("../../../../dialogs");
const dialog_1 = require("../../../extensions/grant-role/dialog");
const uploadInitialValues = {
    files: [],
    tokens: [],
};
const CollectionUploadButton = (props) => {
    const { className, contract, contract: { address }, disabled, variant, onRefreshPage, } = props;
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const api = (0, provider_api_firebase_1.useApi)();
    const handleUploadConfirm = async ({ data }) => {
        const { tokens } = data;
        await api
            .fetchJson({
            url: `/collection/contracts/${address}/upload`,
            data: {
                tokens: tokens.map(({ id: _, ...rest }) => rest),
            },
            method: "POST",
        })
            .then(async () => {
            await onRefreshPage();
        });
    };
    const handleUpload = () => {
        openDialog(dialogs_1.GlobalDialogKeys.COLLECTION_UPLOAD, contract, {
            initialValues: uploadInitialValues,
            validationSchema: dialog_1.grantRoleFieldsValidation,
            message: "dialogs.upload",
            testId: "CollectionUploadDialog",
            onExternalConfirm: handleUploadConfirm,
            componentProps: {
                initialValues: uploadInitialValues,
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleUpload, icon: icons_material_1.PaidOutlined, message: "form.buttons.collectionUpload", className: className, dataTestId: "CollectionUploadButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract), variant: variant }));
};
exports.CollectionUploadButton = CollectionUploadButton;
//# sourceMappingURL=index.js.map